﻿import * as React from 'react';
import { Panel, PanelGroup, Table } from 'react-bootstrap';
import { IOrderListItem } from '../../../Entities';
import * as PlanOrderCombinedStatus from '../../../view/planOrders/PlanOrderCombinedStatus';
import { Translate } from '../../../../../shared/LanguageService';
import OrderListRow from '../../../OrderListRow';

export interface IOrderCollection {
    orderCollectionNumber: string;
    orderNumberRange: string;
    firstOrderNumber: string;
    lastOrderNumber: string;
    name: string;
    orders: IOrderListItem[];
    lastOrderPlacedAt: Date;
    city?: string;
}

type OrderCollectionListProps = {
    items: IOrderCollection[];
    user: any;
    navigateTo: (route: string) => void;
    newOrderId: number | null;
};

function createUniqueOrderListRowKey(order: IOrderListItem): string {
    return `${order.orderCollectionNumber}:${order.orderNumber}:${order.orderPlacedAt}:${order.bookingStart}`;
}

function OrderCollectionList({ items, user, navigateTo, newOrderId }: OrderCollectionListProps) {
    function renderOrderCollectionHeader(orderCollection: IOrderCollection) {
        if (orderCollection.city) {
            return (
                <>
                    <span>
                        {orderCollection.orderCollectionNumber}:{orderCollection.orderNumberRange} -{' '}
                        {orderCollection.name}, {orderCollection.city}
                        {orderCollection.orders.find((order: IOrderListItem) => {
                            return (
                                order.customerDeliveryAnnotation &&
                                order.status &&
                                order.status.value === PlanOrderCombinedStatus.Delivered
                            );
                        }) &&
                            (user.details.role === 'role/broker-agent' ||
                                user.details.role === 'role/broker-agent-assistant' ||
                                user.details.role === 'role/broker-agent-admin') && (
                                <i
                                    style={{ marginLeft: '10px' }}
                                    className="material-icons"
                                    title={Translate(
                                        'view-order/basic-order-info/not-returned-annotations'
                                    )}
                                >
                                    assignment_return
                                </i>
                            )}
                    </span>
                </>
            );
        } else {
            return (
                <span>
                    {orderCollection.orderCollectionNumber}:{orderCollection.orderNumberRange} -{' '}
                    {orderCollection.name}
                </span>
            );
        }
    }

    const listItems = items.map((oc, ocIndex) => {
        const key = oc.orderCollectionNumber;
        return (
            <PanelGroup
                accordion
                id={`order-collection-group-${ocIndex}`}
                key={key}
                defaultActiveKey={ocIndex}
            >
                <Panel className="expand-icon">
                    <Panel.Heading>
                        <Panel.Title toggle>{renderOrderCollectionHeader(oc)}</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible>
                        <Table className="order-table" hover responsive>
                            <thead>
                                <tr>
                                    <th className="hidden-sm hidden-xs">
                                        {Translate('orders/list/header/order-collection-number')}
                                    </th>
                                    <th className="hidden-sm hidden-xs">
                                        {Translate('orders/list/header/order-placed-at')}
                                    </th>
                                    <th>{Translate('orders/list/header/booked')}</th>
                                    <th>{Translate('orders/list/header/photographer')}</th>
                                    <th className="hidden-sm hidden-xs">
                                        {Translate('orders/list/header/package')}
                                    </th>
                                    <th className="hidden-sm hidden-xs">
                                        {Translate('orders/list/header/status')}
                                    </th>
                                    <th className="hidden-sm hidden-xs" />
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {oc.orders.map((order: IOrderListItem) => (
                                    <OrderListRow
                                        order={order}
                                        key={createUniqueOrderListRowKey(order)}
                                        user={user}
                                        navigateTo={navigateTo}
                                        isNewOrder={newOrderId === order.id.toString()}
                                    />
                                ))}
                            </tbody>
                        </Table>
                    </Panel.Body>
                </Panel>
            </PanelGroup>
        );
    });

    return <div className="accordion-as-table">{listItems}</div>;
}

export default OrderCollectionList;
